<template>
  <div>
    <template>
      <Card class="px-3 py-3 mb-3">
        <div class="text-jet font-normal leading-5 text-base flex flex-col gap-2 bg-color px-3 py-3 mb-5 rounded-md">
          <p>
            Pay Scale entries define the exact salary assigned to each employee  in your organisation. 
            Every employee's salary is resolved at payroll run time by matching their classification to the corresponding entry here.
          </p>
        </div>
        <div class="mx-3 mt-6">
          <Card class="mt-6 p-5">
            <div class="flex gap-2 mb-6" style="justify-content: flex-end">
              <Button @click="onPayScaleActions('importPayScale')"
                class="flex items-center justify-center text-dynamicBackBtn w-28 h-10 bg-white border border-dynamicBackBtn"
              >
                Import
              </Button>
              <Button @click="onPayScaleActions('addNewPayScale')"
                class="flex items-center justify-center text-white bg-dynamicBackBtn w-28 h-10"
              >
                Add New
              </Button>
            </div>
          </Card>
        </div>
        <template v-slot:footer>
          <card-footer reloadcard @reload="reload()"/>
        </template>
      </Card>
      <template v-if="payScales.length">
        <Table
          :headers="headers"
          :items="payScales"
          aria-label="payScales"
          class="w-full pt-4 mb-4"
          :has-number="true"
          :loading="isLoading"
        >
          <template v-slot:item="{ item }">
            <div v-if="item.jobTitleNames">
              <div v-if="item.data.jobTitleNames?.length">
                    <div class="flex flex-col justiy-start gap-2">
                        <div class="flex flex-row justify-between items-center gap-1">
                        <p class="text-sm text-darkPurple">
                            {{ item.data.jobTitleNames[0] }}
                        </p>
                        <template v-if="item.data.jobTitleNames.length - 1 > 0">
                            <p class="text-xs text-flame font-bold">
                            +{{ item.data.jobTitleNames.length - 1 }}
                            </p>
                        </template>
                        </div>
                        <template v-if="item.data.jobTitleNames.length > 1">
                        <div @click="
                            (activeDesignationNames = item.data.jobTitleNames),
                            (isOpenDesignationNames = true)
                            ">
                            <p class="text-xs text-blueCrayola font-semibold cursor-pointer">
                                View Trail
                            </p>
                        </div>
                        </template>
                    </div>
              </div>
              <div v-else class="font-normal text-sm leading-5 text-darkPurple">
                -----
              </div>
            </div>
            <div v-else-if="item.jobClassificationNames">
              <div v-if="item.data.jobClassificationNames?.length">
                  <div class="flex flex-col justiy-start gap-2">
                      <div class="flex flex-row justify-between items-center gap-1">
                          <p class="text-sm text-darkPurple">
                            {{ item.data.jobClassificationNames[0] }}
                          </p>
                          <template v-if="item.data.jobClassificationNames.length - 1 > 0">
                            <p class="text-xs text-flame font-bold">
                            +{{ item.data.jobClassificationNames.length - 1 }}
                            </p>
                          </template>
                      </div>
                      <template v-if="item.data.jobClassificationNames.length > 1">
                        <div @click="
                          (activeJobClassificationNames = item.data.jobClassificationNames),
                          (isOpenJobClassificationNames = true)
                          ">
                          <p class="text-xs text-blueCrayola font-semibold cursor-pointer">
                              View Trail
                          </p>
                        </div>
                      </template>
                  </div>
              </div>
              <div v-else class="font-normal text-sm leading-5 text-darkPurple">
                -----
              </div>
            </div>
            <div v-if="item.levelNames">
              <span class="font-normal text-sm leading-5 text-darkPurple whitespace-nowrap">
                {{ item.data.levelNames?.[0] ? item.data.levelNames[0] : '----' }}
              </span>
            </div>
            <div v-if="item.payScaleId">
              <span class="font-normal text-sm leading-5 text-darkPurple">
                {{ item.data.payScaleId ? item.data.payScaleId : '-----' }}
              </span>
            </div>
            <div v-if="item.payScaleAmount">
              <span class="font-normal text-sm leading-5 text-darkPurple">
                 {{ item.data.payScaleAmount ? item.data.payScaleAmount : '-----' }}
              </span>
            </div>
            <div v-else-if="item.id">
              <Menu left style-name="margin-right:20px" class="my-2">
                <template v-slot:title>
                  <Icon icon-name="more_icon" size="xs" />
                </template>
                <div class="w-28 h-18 px-2 py-2 flex flex-col justify-start items-start gap-2">
                  <div @click="onPayScaleActions('editPayscale', item.data.id)" class="w-full">
                    <div
                      class="w-full px-2 py-1 rounded-md flex justify-start items-center gap-2 cursor-pointer hover:bg-cultured">
                      <Icon icon-name="edit" class-name="text-blueCrayola" size="xs" />
                      <span class="text-sm font-normal leading-5 text-darkPurple">Edit</span>
                    </div>
                  </div>
                  <div @click="onPayScaleActions('deletePayscale', item.data.id)" class="w-full">
                    <div
                      class="w-full px-2 py-1 rounded-md flex justify-start items-center gap-2 cursor-pointer hover:bg-cultured">
                      <Icon icon-name="delete" class-name="text-flame bg-white" size="xs" />
                      <span class="text-sm font-normal leading-5 text-darkPurple">Delete</span>
                    </div>
                  </div>
                </div>
              </Menu>
            </div>
          </template>
        </Table>
      </template>
      <template v-else>
        <div class="flex flex-col justify-center items-center gap-5 px-10 py-20">
          <Icon
            icon-name="paygrade_Illustration"
            size=""
            class-name="w-56 h-56"
          />
          <p class="font-normal text-base leading-5 text-jet text-center">
            An Overview of Range Spreads can be found here. 
            This is empty now, but you can start adding range spreads to populate this area.
          </p>
        </div>
      </template>
    </template>
    <template>
      <Modal v-if="isOpenDelete">
        <Card class="p-5 flex flex-col max-w-md">
          <div class>
            <p class="font-bold ml-4 my-5 text-center">
              Are you sure you want to delete this payScale?
            </p>
            <div class="flex justify-end items-center gap-2">
              <Button @click="onDelete(delPayScaleId)"
                class="flex items-center justify-center text-white bg-dynamicBackBtn w-28 h-10"
              >
                Delete
              </Button>
              <Button @click="isOpenDelete = false"
                class="flex items-center justify-center text-dynamicBackBtn w-28 h-10 bg-white border border-dynamicBackBtn"
              >
                Cancel
              </Button>
            </div>
          </div>
        </Card>
      </Modal>
    </template>
    <template>
      <RightSideBar v-if="isOpenDesignationNames" @close="isOpenDesignationNames = false"
        button-class="bg-dynamicBackBtn text-white" :close-button="true">
        <template v-slot:title>
          <div class="flex justify-start items-center">
            <p class="text-darkPurple font-bold text-lg leading-5 p-0 -ml-2">
              View All Positions
            </p>
          </div>
        </template>
        <template v-slot:default>
          <div class="flex flex-col justify-start gap-2">
            <Card v-for="(name, index) in activeDesignationNames" :key="index" class="w-full">
              <div class="flex flex-row items-center justify-start gap-2 mx-5 my-3">
                <Icon icon-name="icon-grid" class="text-romanSilver" size="xxs" />
                <h6 class="font-semibold text-sm text-jet capitalize">
                  {{ name }}
                </h6>
              </div>
            </Card>
          </div>
        </template>
      </RightSideBar>
    </template>
    <template>
      <RightSideBar v-if="isOpenJobClassificationNames" @close="isOpenJobClassificationNames = false"
        button-class="bg-dynamicBackBtn text-white" :close-button="true">
        <template v-slot:title>
          <div class="flex justify-start items-center">
            <p class="text-darkPurple font-bold text-lg leading-5 p-0 -ml-2">
              View All Job Family
            </p>
          </div>
        </template>
        <template v-slot:default>
          <div class="flex flex-col justify-start gap-2">
            <Card v-for="(name, index) in activeJobClassificationNames" :key="index" class="w-full">
              <div class="flex flex-row items-center justify-start gap-2 mx-5 my-3">
                <Icon icon-name="icon-grid" class="text-romanSilver" size="xxs" />
                <h6 class="font-semibold text-sm text-jet capitalize">
                  {{ name }}
                </h6>
              </div>
            </Card>
          </div>
        </template>
      </RightSideBar>
    </template>
    <add-edit-pay-scale v-if="isAddNewPayScale"
      :pay-scale-cred="payScaleCredentials"
      :edit-mode="editMode" :group-id="groupId" 
      :name="name" :pay-scale-group-type="payScaleGroupType"
      @close="isAddNewPayScale = false, editMode = false"
      @reload="reload()"
    />
    <import-employee :open-modal="isOpenImport" @close="isOpenImport = false"
        :isOverwriteEmployee="false" :isTemplate="true" @download="downloadCompensationTemplate()"
        @reload-employees="reload()" @importEmployee="importCompensation" :url=" url" 
        :title="`Import Compensation Data`" :is-employee-directory="false" :isDisplayProgressBar="false"
    />
  </div>
</template>

<script>
  import Table from "@scelloo/cloudenly-ui/src/components/table"
  import Card from "@scelloo/cloudenly-ui/src/components/card"
  import Loader from "@scelloo/cloudenly-ui/src/components/loader"
  import Icon from "@/components/Icon"
  import Button from "@/components/Button";
  import CardFooter from "@/components/CardFooter"
  import Menu from "@/components/Menu";
  import Modal from "@/components/Modal";
  import ImportEmployee from "@/components/importEmployee";

  export default {
    name: "PayScales",

    components: {
      Loader,
      Card,
      Table,
      Icon,
      Button,
      CardFooter,
      Menu,
      Modal,
      ImportEmployee,
      RightSideBar: () => import("@/components/RightSideBar"),
      AddEditPayScale: () => import("./Modals/AddEditPayScale.vue"),
    },

    data() {
      return {
        activeDesignationNames: [],
        isOpenDesignationNames: false,
        activeJobClassificationNames: [],
        isOpenJobClassificationNames: false,
        editMode: false,
        isOpenDelete: false,
        isLoading: true,
        isAddNewPayScale: false,
        payScales: [],
        headers: [
          { title: "Role", value: "jobTitleNames" },
          { title: "job family", value: "jobClassificationNames" },
          { title: "job level ID", value: "levelNames" },
          { title: "pay scale ID", value: "payScaleId" },
          { title: "pay scale", value: "payScaleAmount" },
          { title: "", value: "id", image: true },
        ],
        payScaleCredentials: {},
        delPayScaleId: "",
        url: `${process.env.VUE_APP_UPLOAD_CLOUDENLY_FILES}/document-management/upload/designations`,
        isOpenImport: false,
        groupId: '',
        name: '',
        payScaleGroupType: ''
      };
    },

    methods: {
      async onPayScaleActions(setAction, payload) {
        try {
          if (setAction === "importPayScale") {
            await this.$handlePrivilege("compensationPayscale", "importPayScale");
            this.isOpenImport = true;
          } else if (setAction === "addNewPayScale") {
            await this.$handlePrivilege("compensationPayscale", "addNewPayScale");
            this.isAddNewPayScale = true;
          } else if (setAction === "editPayscale") {
            await this.$handlePrivilege("compensationPayscale", "editPayscale");
            this.onEditOnePayScale(payload);
          } else if (setAction === "deletePayscale") {
            await this.$handlePrivilege("compensationPayscale", "deletePayscale");
            this.delPayScaleId = payload;
            this.isOpenDelete = true;
          }
        } catch (error) {
          const message = "You do not have permission to perform this task";
          this.$toasted.error(message, { duration: 3000 });
        }
      },
      async reload(){
        await this.getPayScales();
      },
      async getPayScales(){
        this.isLoading = true;
        try {
          const { data } = await this.$_getAllOrgPayScales();
          this.payScales = data.data.groups[0].payScales;
          this.groupId = data.data.groups[0].id;
          this.name = data.data.groups[0].name;
          this.payScaleGroupType = data.data.payScaleGroupType;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false
          this.$toasted.error('Error fetching pay scale', {duration: 3000})
        }
      },
      onDelete(payScaleId) {
        this.isLoading = true;
        this.isOpenDelete = false;

        this.$_deleteOnePayScale(payScaleId)
          .then(({ data }) => {
            this.$toasted.success(data.message, { duration: 3000 });
            this.isLoading = false;
            this.getPayScales();
          })
          .catch((error) => {
            this.$toasted.error(error.message, { duration: 3000 });
            this.isLoading = false;
          });
      },
      onEditOnePayScale(payScaleId){
        this.$_getOnePayScale(payScaleId)
        .then(({ data }) => {
          this.payScaleCredentials = data.data.payScale;
          this.payScaleCredentials.levelIds = data.data.payScale?.levelIds?.[0];
          this.editMode = true;
          this.isAddNewPayScale = true;
          return
        }).catch((error) => {
          this.editMode = false;
          this.isAddNewPayScale = false;
          this.$toasted.error(error.message, { duration: 3000 });
        });
      },
      async importCompensation(fileUrl, overwriteEmployee, { resolve, reject }) {
        try {  
          const payload = {
            fileUrl,
          };
          const response = await this.$_importCompensation(payload, this.groupId);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      },
      async downloadCompensationTemplate(){
        try {
          const response = await this.$_getCompensationTemplate(this.groupId);
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = `Compensation Template`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
            return this.$toasted.error(`Error downloading file`,{duration: 6000});
        }
      }
    },
    async mounted(){
      await this.getPayScales();
    },
  };
</script>
<style scoped>
.bg-color{
  border: 1px solid #E993235C;
  background: #E9932314;
}
</style>